import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 历史记录
export function history(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/search/history',
    method: 'get',
    params
  })
}
// 删除历史记录
export function delhistory(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/search/history',
    method: 'DELETE',
    params
  })
}
